import { Injectable } from '@angular/core';
import { SocketMiddlewareService } from './socket-middleware.service';
import { ElementIntegrationEvents } from 'icreate/common/io-event/websocket-message';

@Injectable({
    providedIn: 'root',
})
export class ElementIntegrationSocketService {
    constructor(private socketService: SocketMiddlewareService) {}

    elementIntegrationCreated$() {
        return this.socketService.receiveMessageObserver(ElementIntegrationEvents.ELEMENT_INTEGRATION_CREATED);
    }

    elementIntegrationUpdated$() {
        return this.socketService.receiveMessageObserver(ElementIntegrationEvents.ELEMENT_INTEGRATION_UPDATED);
    }

    elementIntegrationDeleted$() {
        return this.socketService.receiveMessageObserver(ElementIntegrationEvents.ELEMENT_INTEGRATION_DELETED);
    }
}
